import * as React from 'react';
import { useSelector } from 'react-redux';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { RealtorRequestTrapContainer } from 'shared/containers/valuationTraps';
import { isNewbuildingSelector, selectIsAgent, selectIsOfferOwnedByUser } from 'shared/selectors';
import { selectIsCpdAvailable } from 'shared/selectors/cpd/cpd';
import { isSuburbanSelector } from 'shared/selectors/suburban/isSuburbanSelector';

export const BannerTrapContainerLoader: React.FC = () => {
  const isCpdAvailable = useSelector(selectIsCpdAvailable);

  const isAgent = useSelector(selectIsAgent);
  const isOfferByUser = useSelector(selectIsOfferOwnedByUser);
  const isSuburban = useSelector(isSuburbanSelector);
  const isNewbuilding = useSelector(isNewbuildingSelector);

  const offerApproveForCpd = isCpdAvailable && !isNewbuilding && !isOfferByUser && !isAgent;

  if (!offerApproveForCpd && !isSuburban) {
    return (
      <CardSectionNew hideForPrint withBorders>
        <RealtorRequestTrapContainer withoutBorders={true} />
      </CardSectionNew>
    );
  }

  return null;
};
